import React, { Component } from 'react'
import FAIcon from './FAIcon'

import '../css/FICTextButton.css'
import PropTypes from 'prop-types'
import { buildDataSetObject } from './componentsUtils'
import styled from 'styled-components'

/*

PROPS:
- text: (default "")
- color: (default primary)
- size: (default large)
- iconLeft: (default undefined)
- iconRight: (default undefined)
- style
- onClick
- href
- loading
- disabled
*/

class FICTextButton extends Component {
  constructor (props) {
    super(props)
    this.clickable = true
  }

  render () {
    const props = this.props
    const color = props.color ? props.color : 'primary'
    const size = props.size ? props.size : 'large'
    const disable = props.disabled ? 'btn-disabled' : ''
    const className = 'fic-text-button btn-flat ' + color + ' ' + size + ' ' + disable + (props.className ? (' ' + props.className) : '')
    const dataSet = buildDataSetObject(props.dataSet)

    let iconLeft = null; let iconRight = null
    if (props.loading) {
      iconLeft = <Icon name='circle-o-notch fa-spin' style={{ marginRight: props.text ? 3 : 0 }} />
    } else if (props.iconLeft) {
      iconLeft = <Icon name={props.iconLeft} style={{ marginRight: props.text ? 4 : 0 }} />
    }
    if (props.iconRight) {
      iconRight = <Icon name={props.iconRight} style={{ marginLeft: props.text ? 4 : 0 }} />
    }
    return <a
      className={className}
      style={props.style}
      onClick={() => {
        if (!this.clickable || props.loading || props.disabled) {
          return
        }
        this.clickable = false
        setTimeout(() => {
          this.clickable = true
        }, 500)
        if (props.onClick) {
          props.onClick()
        }
      }}
      href={props.href}
      target={props.target}
      {...dataSet}
      {...props.nativeProps}>
      {iconLeft}
      {props.text}
      {iconRight}
    </a>
  }
}

const Icon = styled(FAIcon)`
  display: inline;
`

FICTextButton.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  href: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconLeft: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  iconRight: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  style: PropTypes.object,
  onClick: PropTypes.func,
  disabled: PropTypes.bool
}

FICTextButton.defaultProps = {
  text: '',
  color: 'primary',
  size: 'large',
  href: undefined,
  iconLeft: undefined,
  iconRight: undefined,
  style: undefined,
  onClick: undefined,
  disabled: false
}

export default FICTextButton



// WEBPACK FOOTER //
// ./src/common/components/js/FICTextButton.js